import {BoxProps} from "@mui/material";
import {PropsWithChildren} from "react";
import {Container} from "../components";
import {spacing} from "../theme";

type PageContentProps = PropsWithChildren<{
  sx?: BoxProps["sx"];
}>;

export const PageContent = ({children, sx}: PageContentProps) => (
  <Container gap={6} sx={{pb: spacing[6], ...sx}}>
    {children}
  </Container>
);
